import { DATA_TYPE_SERVICE_NAME, DataTypeService, DataTypeGroupService, DATA_TYPE_GROUP_SERVICE_NAME } from "../../../services/data-type"
import { UserSessionService, USER_SESSION_SERVICE_NAME } from "../../../services/user-session"

import { IMPORT_SERVICE_NAME, IMPORT_ERRORS_SUMMARY_SERVICE_NAME, IMPORT_GRID_SERVICE_NAME, IMPORT_DATA_SERVICE_NAME, ImportService, ImportErrorsSummaryService, ImportGridService, ImportDataService } from "./services"
import { ImportDirective } from "./import.directive"
import { COMPONENT_NAME } from "./import.controller"


export const IMPORT_MODULE_NAME = 'simax.common.import'

const module = angular.module(IMPORT_MODULE_NAME, [])

module.directive(COMPONENT_NAME, [() => new ImportDirective()])

module.service(IMPORT_SERVICE_NAME, [USER_SESSION_SERVICE_NAME, (userSession: UserSessionService) => new ImportService(userSession)])
module.service(IMPORT_ERRORS_SUMMARY_SERVICE_NAME, [ImportErrorsSummaryService])
module.service(IMPORT_GRID_SERVICE_NAME, [USER_SESSION_SERVICE_NAME, (userSessionService: UserSessionService) => new ImportGridService(userSessionService)])

module.service(
    IMPORT_DATA_SERVICE_NAME,
    [
        DATA_TYPE_SERVICE_NAME,
        DATA_TYPE_GROUP_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        (
            dataTypeService: DataTypeService,
            dataTypeGroupService: DataTypeGroupService,
            userSessionService: UserSessionService
        ) => new ImportDataService(dataTypeService, dataTypeGroupService, userSessionService)
    ]
)

